import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HistoriqueModel } from '../models/historique/historique.model';
import { SearchHistoriqueModel } from '../models/historique/search-historique.model';

@Injectable({
  providedIn: 'root',
})
export class HistoriqueService {
  private baseUrl = `${environment.apiUrl}/api/historiques`;

  constructor(private http: HttpClient) {}

  // Ajouter une trace historique
  addHistorique(historique: HistoriqueModel): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}`, historique);
  }

  // Récupérer une trace par ID
  getById(id: number): Observable<HistoriqueModel> {
    return this.http.get<HistoriqueModel>(
      `${environment.apiUrl}/api/historique/${id}`
    );
  }

  // Récupérer les traces d'une entreprise
  getByEntreprise(uidEntreprise: string): Observable<HistoriqueModel[]> {
    return this.http.get<HistoriqueModel[]>(
      `${this.baseUrl}/ent/${uidEntreprise}`
    );
  }

  // Récupérer les traces d’un objet (user, ticket, etc.)
  getByObject(uidObject: string): Observable<HistoriqueModel[]> {
    return this.http.get<HistoriqueModel[]>(`${this.baseUrl}/obj/${uidObject}`);
  }

  // Recherche par mot-clé
  searchHistorique(keyword: string): Observable<HistoriqueModel[]> {
    const body: SearchHistoriqueModel = { keyword };
    return this.http.post<HistoriqueModel[]>(`${this.baseUrl}/search`, body);
  }

  // Anonymiser un objet (par son uid)
  anonymize(uidObject: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/anonymize`, { uidObject });
  }
}
